import { AbstractCommand } from '../command';

export class UpdateTheUserInterfaceStatesForTheUserCommand extends AbstractCommand {
	public readonly name = 'IFS\\StateProvider\\Command\\Command\\UpdateTheUserInterfaceStatesForTheUserCommand';

	constructor(jsonEncodedState: string) {
		super();
		this.parameters = {
			jsonEncodedState: jsonEncodedState,
		};
	}
}
